import "../../assets/MessageInput.css";
import { jsxs as a, jsx as s } from "react/jsx-runtime";
import { c as u } from "../../index-0371017d.js";
import { useRef as _, useEffect as h } from "react";
import { Lock as I } from "../icons/Lock.js";
import { UpArrow as x } from "../icons/UpArrow.js";
const b = "_messageInput_f8f2z_1", M = "_messageBorder_f8f2z_19", T = "_messageInputTextArea_f8f2z_22", N = "_messageInputDesktop_f8f2z_28", v = "_messageInputControl_f8f2z_31", C = "_secureMessage_f8f2z_39", k = "_secureMessageText_f8f2z_44", z = "_emergencyText_f8f2z_50", y = "_messageButton_f8f2z_58", B = "_messageInputMobile_f8f2z_78", e = {
  messageInput: b,
  messageBorder: M,
  messageInputTextArea: T,
  messageInputDesktop: N,
  messageInputControl: v,
  secureMessage: C,
  secureMessageText: k,
  emergencyText: z,
  messageButton: y,
  messageInputMobile: B
}, E = "28px", A = "https://patientsupport.rula.com/hc/en-us/articles/22411553547931-Resources-for-patients-in-crisis", U = ({
  name: c,
  onInput: m,
  showEmergencyText: g,
  showLock: p,
  autoFocus: f = !1,
  setMessage: r,
  message: t
}) => {
  const n = _(null), l = () => {
    t.length && (m(t), r(""));
  }, i = c ? `Send ${c} a message...` : "Send a message...", d = () => {
    n.current && (n.current.style.height = E, n.current.style.height = n.current.scrollHeight + "px");
  };
  return h(() => {
    d();
  }, [t]), /* @__PURE__ */ a("div", { className: e.messageInput, children: [
    /* @__PURE__ */ a(
      "div",
      {
        className: u(
          e.messageInputDesktop,
          e.messageInputTextArea
        ),
        children: [
          /* @__PURE__ */ s(
            "textarea",
            {
              "aria-label": "message input field",
              value: t,
              onChange: (o) => r(o.target.value),
              placeholder: i,
              rows: 4,
              autoFocus: f
            }
          ),
          /* @__PURE__ */ a("div", { className: e.messageInputControl, children: [
            p ? /* @__PURE__ */ a("div", { className: e.secureMessage, children: [
              /* @__PURE__ */ s(I, { width: 18, height: 18, stroke: "#777777" }),
              /* @__PURE__ */ s("span", { className: e.secureMessageText, children: "Secure Message" })
            ] }) : /* @__PURE__ */ s("div", {}),
            /* @__PURE__ */ s(
              "button",
              {
                "aria-label": "send message",
                className: e.messageButton,
                onClick: () => l(),
                disabled: !t.length,
                children: "Send"
              }
            )
          ] })
        ]
      }
    ),
    /* @__PURE__ */ a(
      "div",
      {
        className: u(
          e.messageInputMobile,
          e.messageInputTextArea
        ),
        children: [
          /* @__PURE__ */ s(
            "textarea",
            {
              ref: n,
              "aria-label": "message input field",
              value: t,
              onChange: (o) => r(o.target.value),
              placeholder: i,
              rows: 1
            }
          ),
          /* @__PURE__ */ s(
            "button",
            {
              "aria-label": "send message",
              className: e.messageButton,
              onClick: () => l(),
              disabled: !t.length,
              children: /* @__PURE__ */ s(x, { stroke: "#fff" })
            }
          )
        ]
      }
    ),
    g ? /* @__PURE__ */ a("div", { className: e.emergencyText, children: [
      /* @__PURE__ */ s("b", { children: "Messaging is not for urgent communication." }),
      " Call 988 if you are experiencing emotional distress or a suicidal crisis, call 911 for medical emergencies, or view our",
      " ",
      /* @__PURE__ */ s("a", { href: A, target: "_blank", children: "emergency resources" }),
      "."
    ] }) : null
  ] });
};
export {
  U as MessageInput
};
